import {Component, ContentChild, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {AbstractFindAllService} from '../../service/v2/service/findAll/abstractFindAll.service';
import {BehaviorSubject, Subscription} from 'rxjs';
import {SelectFilterElement} from '../../../../components/common/select-filter/select-filter.model';
import {ContentDirective} from '../../../../shared/directives/content.directive';

@Component({
    selector: 'app-select-filter-data',
    templateUrl: './select-filter-data.component.html',
})
export class SelectFilterDataComponent<E> implements OnInit, OnDestroy {

    @Input() parentFormControlName: string;
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() filterElementProcessor: (criteria: string, element: E) => boolean;
    @Input() findAllService: AbstractFindAllService<any, E>;
    // @Input() findOneByAttribute: AbstractFindOneByAttributeService<any, E>;
    @Input() resolveSelectFilterElement: (entity: E) => SelectFilterElement<string | number, E>;
    @Input() errorsMessages: {[key: string]: string};
    @Input() clearable = true;
    @Input() noValueLabel: string;
    @Output() selectionChanged = new EventEmitter<SelectFilterElement<string | number, E>>();

    loading = false;
    elements: BehaviorSubject<SelectFilterElement<string | number, E>[]> = new BehaviorSubject<SelectFilterElement<string | number, E>[]>([]);
    subscriptions: Subscription[] = [];
    error: any;

    @ContentChild(ContentDirective, {static: true, read: TemplateRef}) template: TemplateRef<any>;


    ngOnInit() {
        this.subscriptions.push(this.findAllService.entities$.subscribe(entities => {
            // console.logByType['entity size', entities?.length]);
            this.elements.next(entities.map(value => this.resolveSelectFilterElement(value)));
        }));

        this.subscriptions.push(this.findAllService.loading$.subscribe(value => this.loading = value));
        this.subscriptions.push(this.findAllService.error$.subscribe(value => this.error = value));
    }

    refresh() {
        this.findAllService.refresh();
    }


    ngOnDestroy(): void {
    }

    onSelectionChanged(element: SelectFilterElement<string | number, E>) {
        if (this.selectionChanged) {
            this.selectionChanged.emit(element);
        }
    }
}
